import * as React from "react";

import { IAlert } from "./classes/Alert";
import { IText } from "./classes/Text";

import { LoadingSpinner } from "../Common/LoadingSpinner/LoadingSpinner";
import { UnifiedPublishingLiveAlertDetail } from "./UnifiedPublishingLiveAlertDetail";
import { UnifiedPublishingNoAlertsDetail } from "./UnifiedPublishingNoAlertsDetail";

export interface IUnifiedPublishingModalContentProps {
  liveAlerts: IAlert[];
  numAjaxRequests: number;
  text: IText;
  onClickCloseModalButton: (event: any) => any;
}

export const UnifiedPublishingModalContent = (props: IUnifiedPublishingModalContentProps) => {

  const onMinimise = (event) => {
    event.preventDefault();
    props.onClickCloseModalButton(event);
  };

  let liveAlertComponents: any = null;
  let noAlerts = false;

  const showSpinner = props.numAjaxRequests > 0;

  if (props.numAjaxRequests === 0 && props.text.new !== " ") { // Leave the " " in props.text.new !== " " there! Used as flag whether internationalised text has finished loading, otherwise re-renders component and messes up displaying New icon.
    liveAlertComponents = props.liveAlerts.map((alert) => <UnifiedPublishingLiveAlertDetail alert={alert} text={props.text} key={alert.alertId} />);
    noAlerts = liveAlertComponents.length === 0;
  }

  return (
    <React.Fragment>

      <a className="CMS_dialogClose CMS_dialogMinimize CMS_button CMS_bSquare" title={props.text.minimize} aria-label={props.text.minimize} href="#" onClick={props.onClickCloseModalButton}>
        <em className="fa fa-window-minimize" aria-hidden="true"></em>
        <span className="offScreen">{props.text.minimize}</span>
      </a>

      <div className="CMS_element" aria-live="assertive">
        <div className="CMS_title CMS_T4"><em className="fa fa-exclamation-triangle"></em> {props.text.alerts}</div>
        <div className="CMS_e_row CMS_minimumHeight">

          <LoadingSpinner showSpinner={showSpinner} loadingText={props.text.loading} />

          {liveAlertComponents}

          {noAlerts &&
            <UnifiedPublishingNoAlertsDetail text={props.text} />
          }

        </div>
      </div>

    </React.Fragment>
  );
};
